export default __webpack_public_path__ + "static/media/pdfnoBrand.498b49ea.svg";